import React, { useCallback, useEffect, useState } from "react";
import Chip from "src/components/common/Chip";
import Button from "src/components/common/Button";
import List from "../common/List";
import ShopItem from "./ShopItem";
import GroupItem from "./GroupItem";
import styled from "styled-components";
import { useSelectStoreQuery } from "src/api/userAPI";
import BottomModal, { RefProps } from "../common/BottomModal";
import SearchSortItem from "../filter/SearchSortItem";
import SearchStoreFilerItem from "../filter/SearchStoreFilterItem";
import PaginationCommon from "../common/PaginationCommon";
import setQueryStringVer from "src/utils/reuseQueryString";
import { cloneDeep, isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import SVG from "src/utils/SVG";
import { useAppSelector } from "src/store/actions/action";
import { shallowEqual } from "react-redux";
import { CONTRACT_AXIS, CONTRACT_TYPE_CHIPS, SHOP_TYPE_AXIS, SHOP_TYPE_CHIPS, PERMANENT_LABEL, qualify } from "src/constants/storeAxis";

interface propsData {
  contents?: string | any;
  parentFunc?: any;
}

const ManageShopPanel = (props: propsData) => {
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const sortModalRef = React.useRef<RefProps>(null);
  const filterModalRef = React.useRef<RefProps>(null);

  // 정렬모달
  const openSortModal = useCallback(() => {
    if (sortModalRef.current) sortModalRef.current.modalOpen();
  }, []);

  // 필터모달
  const openFilterModal = useCallback(() => {
    if (filterModalRef.current) filterModalRef.current.modalOpen();
  }, []);

  // ++++++++++++++++++++++++++++++++++++++++ 퍼블영역 끝 ++++++++++++++++++++++++++++++++++++++++

  // 뒤로가기에서 필터를 유지하기 위한 sessionStorage
  const sessionStoragePage = window.sessionStorage.getItem("sPage");
  const sessionStorageContents = window.sessionStorage.getItem("sContents");
  const sessionStorageSort = window.sessionStorage.getItem("sSortName");
  const sessionStorageSortIdx = window.sessionStorage.getItem("sSortIdx");

  const sessionStorageAfter = window.sessionStorage.getItem("sAfter");
  const sessionStorageInit = window.sessionStorage.getItem("sInit");
  const sessionNewStore = window.sessionStorage.getItem("sNewStore");
  const sessionPermanent = window.sessionStorage.getItem("sPermanent");

  const navigate = useNavigate();

  // 초기 값 세팅

  const [api, setApi] = useState({
    apiSkip: true,
    filterData: "",
  });

  const { apiSkip, filterData } = api;

  const [init, setInit] = useState({
    totalPages: 0,
    rerender: false,
    // 매장 구분 한 줄을 계약형태 줄과 매장형태 줄로 나눈다 (VMD-403).
    // 어느 축도 단독으로 충분하지 않다 — 매장형태는 대리점과 직영점을 구분하지
    // 못하고(둘 다 가두), 계약형태는 아울렛을 표현하지 못한다.
    contractType: {
      title: CONTRACT_AXIS,
      chip: [...CONTRACT_TYPE_CHIPS],
      check: CONTRACT_TYPE_CHIPS.map(() => false),
    },
    shopType: {
      title: SHOP_TYPE_AXIS,
      chip: [...SHOP_TYPE_CHIPS],
      check: SHOP_TYPE_CHIPS.map(() => false),
    },
    brandType: {
      title: "브랜드 유형",
      chip: ["MLB", "MLB KIDS", "Discovery", "DUVETICA", "SUPRA", "Sergio Tacchini"],
      check: [false, false, false, false, false, false],
    },
    // dateType: {
    //   title: "기간",
    //   chip: ["1개월", "3개월", "6개월", "12개월"],
    //   check: [false, false, false, false],
    // },
    selectedChips: [],
  });

  const {
    totalPages,
    rerender,
    contractType,
    shopType,
    brandType,
    // dateType,
    selectedChips,
  } = init;

  const [after, setAfter] = useState({
    // 매장 구분 한 줄을 계약형태 줄과 매장형태 줄로 나눈다 (VMD-403).
    // 어느 축도 단독으로 충분하지 않다 — 매장형태는 대리점과 직영점을 구분하지
    // 못하고(둘 다 가두), 계약형태는 아울렛을 표현하지 못한다.
    afterContractType: {
      title: CONTRACT_AXIS,
      chip: [...CONTRACT_TYPE_CHIPS],
      check: CONTRACT_TYPE_CHIPS.map(() => false),
    },
    afterShopType: {
      title: SHOP_TYPE_AXIS,
      chip: [...SHOP_TYPE_CHIPS],
      check: SHOP_TYPE_CHIPS.map(() => false),
    },
    afterBrandType: {
      title: "브랜드 유형",
      chip: ["MLB", "MLB KIDS", "Discovery", "DUVETICA", "SUPRA", "Sergio Tacchini"],
      check: [false, false, false, false, false, false],
    },
    // afterDateType: {
    //   title: "기간",
    //   chip: ["1개월", "3개월", "6개월", "12개월"],
    //   check: [false, false, false, false],
    // },
    afterSelectedChips: [],
  });

  const {
    afterContractType,
    afterShopType,
    afterBrandType,
    // afterDateType,
    afterSelectedChips,
  } = after;

  const [currentPage, setCurrentPage] = useState<number>();

  const [sortIdx, setSordIdx] = useState<number>(0);

  const [sortName, setSortName] = useState<string>();

  const [queryString, setQueryString] = useState({
    typeSearchArray: afterSelectedChips,
    contentsSearchString: "",
    sortSearchString: "",
    pageSearchNumber: 1,
    newStoreSearchString: "",
    permanentSearchString: "",
  });

  const [initVisible, setInitVisible] = useState<boolean>(false);

  const [newStoreToggle, setNewStoreToggle] = useState<boolean>(false);

  // 상설은 계약형태도 매장형태도 아닌 제3의 축이라 칩이 아니라 토글이다 (VMD-403).
  // 배타 칩으로 두면 백화점아울렛이면서 상설인 70곳이 계속 상설로 흡수된다.
  const [permanentToggle, setPermanentToggle] = useState<boolean>(false);

  // 세션으로 api 호출시
  const [sessionAPICall, setSessionAPICall] = useState<boolean>(false);

  // ====================================================================
  // API 영역
  // ====================================================================

  const storeListAPI = useSelectStoreQuery(filterData, { skip: apiSkip });

  // ====================================================================
  // hook 영역
  // ====================================================================

  useEffect(() => {
    return () => {
      const path = location.pathname;
      if (path !== "/manage-list") {
        window.sessionStorage.setItem("sPage", String(currentPage));
        window.sessionStorage.setItem("sContents", props.contents!);
        window.sessionStorage.setItem("sSortName", String(sortName));
        window.sessionStorage.setItem("sSortIdx", String(sortIdx));

        window.sessionStorage.setItem("sAfter", JSON.stringify(after));
        window.sessionStorage.setItem("sInit", JSON.stringify(init));

        window.sessionStorage.setItem("openTab", "0");
        if (newStoreToggle) {
          window.sessionStorage.setItem("sNewStore", "T");
        } else {
          window.sessionStorage.setItem("sNewStore", "");
        }
        if (permanentToggle) {
          window.sessionStorage.setItem("sPermanent", "T");
        } else {
          window.sessionStorage.setItem("sPermanent", "");
        }
      }
    };
  });

  useEffect(() => {
    // 처음 페이지를 1로 세팅해줘도 처음은 undefine으로 세팅이 된다. 왜?
    // setCurrentPage(1);
    setSortName("최신순");
  }, []);

  // API 실행 영역
  useEffect(() => {
    if (queryString) {
      if (sessionAPICall) {
        const searchFilter = setQueryStringVer(queryString);
        setApi({
          ...api,
          filterData: searchFilter,
          apiSkip: false,
        });
      }
    }
  }, [queryString, sessionAPICall]);

  useEffect(() => {
    if (storeListAPI.isSuccess) {
      setCurrentPage(storeListAPI.data.meta.currentPage);
      setInit({
        ...init,
        totalPages: storeListAPI.data.meta.totalPages,
      });
    }
  }, [storeListAPI]);

  useEffect(() => {
    if (!sessionStoragePage && !sessionStorageContents && !sessionStorageAfter && !sessionStorageSort && !sessionNewStore && !sessionPermanent) {
      setQueryString({
        ...queryString,
        contentsSearchString: props.contents,
        pageSearchNumber: 1,
      });
      setCurrentPage(1);
    }
  }, [props.contents]);

  useEffect(() => {
    if (!sessionStoragePage && !sessionStorageContents && !sessionStorageAfter && !sessionStorageSort && !sessionNewStore && !sessionPermanent) {
      if (afterSelectedChips.length > 0) {
        setQueryString({
          ...queryString,
          typeSearchArray: afterSelectedChips,
          pageSearchNumber: 1,
        });
        setCurrentPage(1);
      }
    }
  }, [afterSelectedChips]);

  useEffect(() => {
    setSessionAPICall(true);
    let afterSelectedChipsLength = 0;
    if (!isEmpty(sessionStorageAfter) && typeof sessionStorageAfter !== undefined) {
      const jsonParser = JSON.parse(sessionStorageAfter!);
      afterSelectedChipsLength = jsonParser.afterSelectedChips.length;
    }
    if (
      (!isEmpty(sessionStoragePage) && typeof sessionStoragePage !== undefined && sessionStoragePage !== "1") ||
      (!isEmpty(sessionStorageSort) && typeof sessionStorageSort !== undefined && sessionStorageSort !== "최신순") ||
      (!isEmpty(sessionStorageContents) && typeof sessionStorageContents !== undefined && sessionStorageContents !== "undefined") ||
      afterSelectedChipsLength > 0 ||
      (!isEmpty(sessionNewStore) && typeof sessionNewStore !== undefined && sessionNewStore !== "undefined") ||
      (!isEmpty(sessionPermanent) && typeof sessionPermanent !== undefined && sessionPermanent !== "undefined")
    ) {
      let tempPage: any = 1;
      let tempSortName: any = "";
      let tempAfter: any = [];
      let tempContents: any = "";
      let tempNewStore: any = "";
      let tempPermanent: any = "";
      if (!isEmpty(sessionStorageAfter) && typeof sessionStorageAfter !== undefined) {
        const jsonParser = JSON.parse(sessionStorageAfter!);
        tempAfter = jsonParser.afterSelectedChips;
        setAfter(jsonParser);
      }
      if (!isEmpty(sessionStoragePage) && typeof sessionStoragePage !== undefined) {
        tempPage = sessionStoragePage;
      }
      if (!isEmpty(sessionStorageSort) && typeof sessionStorageSort !== undefined) {
        tempSortName = sessionStorageSort;
        setSortName(sessionStorageSort!);
        setSordIdx(Number(sessionStorageSortIdx));
      }
      if (!isEmpty(sessionStorageContents) && typeof sessionStorageContents !== undefined && sessionStorageContents !== "undefined") {
        tempContents = sessionStorageContents;
        if (props.parentFunc) {
          props.parentFunc(tempContents);
        }
      }
      if (!isEmpty(sessionNewStore) && typeof sessionNewStore !== undefined && sessionNewStore !== "undefined") {
        tempNewStore = sessionNewStore;
        setNewStoreToggle(true);
      }
      if (!isEmpty(sessionPermanent) && typeof sessionPermanent !== undefined && sessionPermanent !== "undefined") {
        tempPermanent = sessionPermanent;
        setPermanentToggle(true);
      }
      setQueryString({
        ...queryString,
        typeSearchArray: tempAfter,
        pageSearchNumber: Number(tempPage),
        contentsSearchString: tempContents,
        sortSearchString: tempSortName,
        newStoreSearchString: tempNewStore,
        permanentSearchString: tempPermanent,
      });
    }
    if (!isEmpty(sessionStorageInit) && typeof sessionStorageInit !== undefined) {
      const jsonParser = JSON.parse(sessionStorageInit!);
      setInit(jsonParser);
    }
    const sessionTime = setTimeout(() => {
      window.sessionStorage.removeItem("sPage");
      window.sessionStorage.removeItem("sContents");
      window.sessionStorage.removeItem("sSortName");
      window.sessionStorage.removeItem("sSortIdx");
      window.sessionStorage.removeItem("sAfter");
      window.sessionStorage.removeItem("sInit");
      window.sessionStorage.removeItem("openTab");
      window.sessionStorage.removeItem("sNewStore");
      window.sessionStorage.removeItem("sPermanent");
    }, 500);

    return () => clearTimeout(sessionTime);
  }, []);

  // 이벤트 영역
  // 적용하기
  const confirmBtn = () => {
    setAfter({
      ...after,
      afterContractType: cloneDeep(contractType),
      afterShopType: cloneDeep(shopType),
      afterBrandType: cloneDeep(brandType),
      // afterDateType: dateType,
      afterSelectedChips: [...selectedChips],
    });

    if (selectedChips.length < 1) {
      setQueryString({
        ...queryString,
        typeSearchArray: [],
        pageSearchNumber: 1,
      });
    }
    if (filterModalRef.current) filterModalRef.current.modalClose();
  };

  const closeBtn = () => {
    setInit({
      ...init,
      contractType: cloneDeep(afterContractType),
      shopType: cloneDeep(afterShopType),
      brandType: cloneDeep(afterBrandType),
      // dateType: { ...afterDateType },
      selectedChips: [...afterSelectedChips],
    });
  };

  const initBtn = () => {
    setInit((prev) => ({
      ...prev,
      // 매장 구분 한 줄을 계약형태 줄과 매장형태 줄로 나눈다 (VMD-403).
      // 어느 축도 단독으로 충분하지 않다 — 매장형태는 대리점과 직영점을 구분하지
      // 못하고(둘 다 가두), 계약형태는 아울렛을 표현하지 못한다.
      contractType: {
        title: CONTRACT_AXIS,
        chip: [...CONTRACT_TYPE_CHIPS],
        check: CONTRACT_TYPE_CHIPS.map(() => false),
      },
      shopType: {
        title: SHOP_TYPE_AXIS,
        chip: [...SHOP_TYPE_CHIPS],
        check: SHOP_TYPE_CHIPS.map(() => false),
      },
      brandType: {
        title: "브랜드 유형",
        chip: ["MLB", "MLB KIDS", "Discovery", "DUVETICA", "SUPRA", "Sergio Tacchini"],
        check: [false, false, false, false, false, false],
      },
      // dateType: {
      //   title: "기간",
      //   chip: ["1개월", "3개월", "6개월", "12개월"],
      //   check: [false, false, false, false],
      // },
      selectedChips: [],
    }));
  };

  const deleteSelectChips = (value: string, idx: number) => {
    // 자식영역(props)의 선택된 검색어 삭제
    const deleteSelect = selectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);

    // 선택값에 축 접두가 붙어 있으므로 같은 축으로 접두를 붙여서 비교한다 (VMD-403).
    contractType.chip.map((selectValue: any, selectIdx: number) => {
      if (qualify(CONTRACT_AXIS, selectValue) === value) {
        contractType.check[selectIdx] = false;
      }
    });

    shopType.chip.map((selectValue: any, selectIdx: number) => {
      if (qualify(SHOP_TYPE_AXIS, selectValue) === value) {
        shopType.check[selectIdx] = false;
      }
    });

    brandType.chip.map((selectValue: any, selectIdx: number) => {
      if (selectValue === value) {
        brandType.check[selectIdx] = false;
      }
    });

    // dateType.chip.map((dateValue: any, selectIdx: number) => {
    //   if (dateValue === value) {
    //     dateType.check[selectIdx] = false;
    //   }
    // });

    setInit({
      ...init,
      selectedChips: deleteSelect,
    });

    setQueryString({
      ...queryString,
      typeSearchArray: deleteSelect,
    });

    // 부모영역(현재)의 선택된 검색어 삭제
    const deleteAfterSelect = afterSelectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);
    setAfter({
      ...after,
      afterSelectedChips: deleteAfterSelect,
    });
  };

  const sortBtn = (e: any) => {
    const sortName = e.target.textContent;
    setSortName(sortName);
    setQueryString({
      ...queryString,
      sortSearchString: sortName,
      pageSearchNumber: 1,
    });
    if (sortModalRef.current) sortModalRef.current.modalClose();
  };

  const permanentBtn = () => {
    setQueryString({ ...queryString, permanentSearchString: permanentToggle ? "" : "T", pageSearchNumber: 1 });
    setCurrentPage(1);
    setPermanentToggle(!permanentToggle);
  };

  const newStoreBtn = () => {
    if (newStoreToggle) {
      setQueryString({ ...queryString, newStoreSearchString: "", pageSearchNumber: 1 });
    } else {
      setQueryString({ ...queryString, newStoreSearchString: "T", pageSearchNumber: 1 });
    }
    setCurrentPage(1);
    setNewStoreToggle(!newStoreToggle);
  };

  // 자식영역으로 넘겨주는 함수 (page 값 받아오기)
  const objectChange = (currentPage: number) => {
    setQueryString({
      ...queryString,
      pageSearchNumber: currentPage,
    });
    setCurrentPage(Number(currentPage));
  };

  const childrenSortIdxFunc = (idx: number) => {
    setSordIdx(idx);
  };

  const setInitFunc = (propsSelectedFliterCheck: boolean) => {
    setInitVisible(propsSelectedFliterCheck);
  };

  const goProfileDetail = (userId: string, groupAddFlag: string) => {
    // window.sessionStorage.setItem("sPage", String(currentPage));
    // window.sessionStorage.setItem("sContents", props.contents!);
    // window.sessionStorage.setItem("sSortName", String(sortName));
    // window.sessionStorage.setItem("sSortIdx", String(sortIdx));

    // window.sessionStorage.setItem("sAfter", JSON.stringify(after));
    // window.sessionStorage.setItem("sInit", JSON.stringify(init));

    // window.sessionStorage.setItem("openTab", "0");

    navigate("/profile/" + userId);
  };

  return (
    <>
      <GroupItem type="S" add={true} />

      <FilterBtnSet>
        <Button variant="contained" br="round" color="secondary" size="medium" onClick={openFilterModal}>
          <SVG name="filter" width={16} height={16} viewBox="0 0 16 16" />
          필터
        </Button>
        <Button variant="contained" br="round" color="secondary" size="medium" onClick={openSortModal}>
          <SVG name="sort" width={14.637} height={16.348} viewBox="0 0 14.637 16.348" />
          {sortName}
        </Button>
        <Button className="only-new" variant="contained" br="round" color={newStoreToggle ? "active" : "secondary"} size="medium" onClick={newStoreBtn}>
          {newStoreToggle ? (
            <SVG name="toggleActive" width={16} height={16} viewBox="0 0 16 16" />
          ) : (
            <SVG name="toggle" width={16} height={16} viewBox="0 0 16 16" />
          )}
          신규매장만
        </Button>
        <Button className="only-new" variant="contained" br="round" color={permanentToggle ? "active" : "secondary"} size="medium" onClick={permanentBtn}>
          {permanentToggle ? (
            <SVG name="toggleActive" width={16} height={16} viewBox="0 0 16 16" />
          ) : (
            <SVG name="toggle" width={16} height={16} viewBox="0 0 16 16" />
          )}
          {PERMANENT_LABEL}
        </Button>
        {afterSelectedChips?.map((v, idx) => {
          return (
            <Chip variant="contained" deleted={true} key={idx} onDelete={() => deleteSelectChips(v, idx)}>
              {v}
            </Chip>
          );
        })}
      </FilterBtnSet>

      <List pd="0 15px" itemPd="25px 0">
        {storeListAPI.isSuccess && storeListAPI.data.data.length > 0 ? (
          <ShopItem
            searchAPIdata={storeListAPI.isSuccess ? storeListAPI : ""}
            profileDetailClick={(userId: string, groupAddFlag: string) => goProfileDetail(userId, groupAddFlag)}
          />
        ) : (
          <NoResult>리스트 결과가 없습니다.</NoResult>
        )}
      </List>

      <BottomModal
        ref={filterModalRef}
        onClick={() => initBtn()}
        onClick2={() => confirmBtn()}
        onClick3={() => closeBtn()}
        modalTitle="검색 필터"
        headerBtn="초기화"
        footerBtn="적용"
        dimClickFun={closeBtn}
        initVisible={initVisible}
      >
        <List pd="0 15px" itemPd="20px 0">
          <SearchStoreFilerItem
            contractType={contractType}
            shopType={shopType}
            brandType={brandType}
            // dateType={dateType}
            selectedChips={selectedChips}
            setInitFunc={(filter: any) => setInitFunc(filter)}
            userBrand={userInfo.brand}
          />
        </List>
      </BottomModal>

      <BottomModal modalTitle="정렬" ref={sortModalRef}>
        <List pd="0 15px">
          <SearchSortItem
            sortData={["최신순", "오래된순", "가나다순", "별점높은순", "별점낮은순", "이행률높은순", "이행률낮은순"]}
            onClick={(e) => sortBtn(e)}
            initIdx={sortIdx}
            parentSortIdxFunc={childrenSortIdxFunc}
          />
        </List>
      </BottomModal>

      {totalPages > 1 && (
        <PaginationCommon
          item_count={10}
          current_page={currentPage}
          total_page={totalPages}
          objectChange={objectChange}
          onClick={() => setInit({ ...init, rerender: rerender ? false : true })}
          viewName="manageList"
        />
      )}
      {/* <Pagination item_count={10} total_page={totalPages} onClick={() => setInit({ ...init, rerender: rerender ? false : true })}  onClick={(e: any) => pageBtn(e)} /> */}
    </>
  );
};

const FilterBtnSet = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > * {
    flex: 0 0 auto;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  > button {
    > svg {
      position: relative;
      top: -1px;
    }
  }
  .only-new {
    > svg {
      top: 2px;
      left: 2px;
    }
  }
`;

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

export default ManageShopPanel;
